module.exports = __webpack_public_path__ + "img/four.39b28cd0.png";